import { Injectable, signal } from '@angular/core';

export type ToastTipo = 'ok' | 'error' | 'info';

export interface Toast {
  id: number;
  tipo: ToastTipo;
  mensaje: string;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private siguienteId = 1;
  readonly toasts = signal<Toast[]>([]);

  ok(mensaje: string): void {
    this.mostrar('ok', mensaje, 3500);
  }

  error(mensaje: string): void {
    this.mostrar('error', mensaje, 6000);
  }

  info(mensaje: string): void {
    this.mostrar('info', mensaje, 4500);
  }

  cerrar(id: number): void {
    this.toasts.update(lista => lista.filter(t => t.id !== id));
  }

  private mostrar(tipo: ToastTipo, mensaje: string, duracionMs: number): void {
    const id = this.siguienteId++;
    this.toasts.update(lista => [...lista.slice(-3), { id, tipo, mensaje }]);
    setTimeout(() => this.cerrar(id), duracionMs);
  }
}
